import {
    connect,
    disconnect,
    authenticate,
    deauthenticate,
} from '@/service/websocket.service'

export default store => {
    let currentBackendUrl = null
    let currentBaseToken = null
    let currentSharingToken = null
    let lastLiveState = false

    store.watch(
        state => ({
            live: store.getters['map/liveUpdatesEnabledConditionally'],
            baseToken: state.auth.jwt?.access,
            sharingToken: state.sharing.sharingToken,
            backend: state.auth.backend,
        }),
        ({ live, baseToken, sharingToken, backend }) => {
            const backendUrl = backend?.websocket_url

            // disable all
            if (!live) {
                disconnect()
                currentBackendUrl = null
                currentBaseToken = null
                currentSharingToken = null
                lastLiveState = false
                return
            }

            // backend change → full reconnect
            if (backendUrl && backendUrl !== currentBackendUrl) {
                connect(backendUrl, store)
                currentBackendUrl = backendUrl

                currentBaseToken = null
                currentSharingToken = null
            }

            // base token logic (equivalent to subscribeToBaseUpdates)
            if (!baseToken) {
                currentBaseToken = null
                deauthenticate('base')
            } else if (baseToken !== currentBaseToken || !lastLiveState) {
                authenticate(baseToken, 'base')
                currentBaseToken = baseToken
            }

            // sharing token logic (equivalent to subscribeToSharingUpdates)
            if (!sharingToken) {
                currentSharingToken = null
                deauthenticate('sharing')
            } else if (sharingToken !== currentSharingToken || !lastLiveState) {
                authenticate(sharingToken, 'sharing')
                currentSharingToken = sharingToken
            }

            lastLiveState = live
        },
        { immediate: true }
    )
}
